/**
 * @author Tommy Brière
 * @copyright (c) 2013 Groupe PVP
 * @fileoverview Call function one after another, each function must call complete
 * 	when it is completed
**/
(function($g) {
    "use strict";
	
	function FunctionList() {
		var ready = true;
        var actions = [];
        var empty = function() {};

        function complete() {
        	ready = true;
        	checkR();
        }
        
        function checkR() {
            if (ready) {
                var f = actions.shift();
                if (f) {
                	ready = false;
                    f(complete);
                } else {
                    empty();
                }
            }
        }
        
        function whenReady(callback) {
            if (callback) {
                actions.push(callback);
                checkR();
            }
        }
               
        /**
         * Ajoute une opération à la fin de la liste
         */
        this.exec = whenReady;    
        /**
         * Me en place une fonction à appelé quand il n'y a plus rien à faire
         * Attention, une seule function est supporté à la fois
         * @param {function} f
         * @returns {undefined}
         */
        this.empty = function(f) {
            empty=f;
        };
        /**
         * Retourne vrai si il n'y aucune opération en cours
         * @returns {Boolean}
         */
        this.isReady = function() {
            return ready;
        };
	}
	
	$g.FunctionList = FunctionList;
	
})(PVPGEngine);